import { useQuery } from '@tanstack/react-query';
import { METHOD, sendJSONRequest } from '@/state/http-request.helpers';
import { useAuth } from '@clerk/clerk-react';

export const GET_LIVE_LANGUAGE_STATUS_QUERY_KEY = 'get-live-language-status';

export type LiveLanguageStatusDto = {
  enabled: boolean;
  captions: { stagePlayer: boolean; roomPlayer: boolean; onlinePlayer: boolean };
  showLanguageMarker: boolean;
  languages: string[];
  clearEpoch: number;
  publisherIdentity: string | null;
  status: 'stopped' | 'starting' | 'running' | 'waiting_for_audio' | 'degraded' | 'stopping';
  statusReason?: string;
  translationTemplateMissing?: { stagePlayer?: boolean; roomPlayer?: boolean; onlinePlayer?: boolean };
  entitled: boolean;
  killSwitchOff: boolean;
  entityRef: string;
};

export const useLiveLanguageStatusQuery = (entityRef: string | undefined, options?: { enabled?: boolean }) => {
  const { getToken } = useAuth();
  const enabled = !!entityRef && (options?.enabled ?? true);

  return useQuery({
    queryKey: [GET_LIVE_LANGUAGE_STATUS_QUERY_KEY, entityRef],
    queryFn: async () => {
      const token = await getToken();
      const url = `${import.meta.env.VITE_API_URL}/player/live-context-state/live-language?entityRef=${encodeURIComponent(entityRef!)}`;
      return sendJSONRequest({ url, method: METHOD.GET, token: token ?? '' }) as Promise<LiveLanguageStatusDto>;
    },
    enabled,
    refetchInterval: 8000,
  });
};
